const contactInfo = [
  {
    label: "Address",
    icon: "ri-map-pin-2-line",
    lines: ["KLIMENT OHRIDSKI 105", "STRUMICA, 2400", "North Macedonia"],
  },
  {
    label: "Email",
    icon: "ri-mail-line",
    lines: ["info@mani-doo.com"],
  },
  {
    label: "Phone",
    icon: "ri-phone-line",
    lines: ["+1 3186186034"],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#111111] pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Top area */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start pb-20 border-b border-white/10">
          {/* Left: Branding */}
          <div>
            <span className="text-xs tracking-[0.35em] uppercase text-amber-400/70 font-medium mb-4 block">
              Get In Touch
            </span>
            <h2 className="text-6xl md:text-7xl font-black text-white leading-none mb-6">
              MANI<br />
              <span className="text-amber-400">D.O.O</span>
            </h2>
            <p className="text-base text-white/50 leading-relaxed max-w-sm">
              We are a team of dedicated iOS developers committed to building applications that protect privacy and enhance everyday mobile experiences.
            </p>

            {/* Decorative image */}
            <div className="mt-10 w-full max-w-sm h-56 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/76ce15d2815101b63e55e9d8ac7144f3.jpg"
                alt="Digital security concept"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Contact details */}
          <div className="flex flex-col gap-10">
            {contactInfo.map((item) => (
              <div key={item.label} className="flex gap-5 items-start">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-amber-400/10 flex-shrink-0 mt-0.5">
                  <i className={`${item.icon} text-xl text-amber-400`} />
                </div>
                <div>
                  <p className="text-xs tracking-[0.25em] uppercase text-white/40 font-semibold mb-2">
                    {item.label}
                  </p>
                  {item.lines.map((line) => (
                    <p key={line} className="text-base text-white/85 leading-relaxed">
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}

            {/* Divider line */}
            <div className="w-full h-px bg-white/10 mt-4" />

            {/* Additional info */}
            <div className="grid grid-cols-2 gap-8">
              <div>
                <p className="text-xs tracking-[0.25em] uppercase text-white/40 font-semibold mb-2">
                  Platform
                </p>
                <p className="text-white/85 text-base">iOS</p>
              </div>
              <div>
                <p className="text-xs tracking-[0.25em] uppercase text-white/40 font-semibold mb-2">
                  Specialization
                </p>
                <p className="text-white/85 text-base">Mobile Security &amp; Utility</p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer bottom bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/30">
            &copy; {new Date().getFullYear()} MANI D.O.O. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <img
              src="https://public.readdy.ai/ai/img_res/71e90ebe-13bc-454b-943b-6bd0da7f06ea.png"
              alt="MANI D.O.O"
              className="h-6 w-auto object-contain opacity-40"
            />
          </div>
          <p className="text-sm text-white/30">STRUMICA, North Macedonia</p>
        </div>
      </div>
    </section>
  );
}
